import { Injectable } from '@angular/core';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { Http, Response } from '@angular/http';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NatureService extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  getAll() {
    return this._http.get(constant.URL_NATURE, this.getHeader()).map(res => res.json());
  }

  get(bankId) {
    return this._http.get(constant.URL_NATURE + '/' + bankId, this.getHeader()).map(res => res.json());
  }

  store(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_NATURE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  update(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_NATURE, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/administration/nature.service.ts